module.exports = __webpack_public_path__ + "media/04 - Perturbator - Miami Disco.9fbaf3ac.mp3";